import { render, staticRenderFns } from "./driveinform.vue?vue&type=template&id=1cb8aa31&scoped=true"
import script from "./driveinform.vue?vue&type=script&lang=js"
export * from "./driveinform.vue?vue&type=script&lang=js"
import style0 from "./driveinform.vue?vue&type=style&index=0&id=1cb8aa31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb8aa31",
  null
  
)

export default component.exports